/// <reference path="DOMAttached.js" />
/// <reference path="SaveableSVG.js" />
/// <reference path="DraggableSvgItem.js" />
/// <reference path="ColorableSvgItem.js" />
/// <reference path="MiniMeAccessoryManager.js" />
/// <reference path="ColorSelector.js" />
/// <reference path="ChangeableMiniMeItem.js" />
/// <reference path="MiniMeSpeechBubble.js" />
/// <reference path="GenericSounds.js" />
/// <reference path="../../../gulp/node_modules/soundmanager2/script/soundmanager2-nodebug.js" />
/// <reference path="ProgressIndicator.js" />

// Note that for historic reasons, some parts of the MiniMe unfortunately live in global variables while some other
// parts (e.g., the accessories) live in local variables.
var MiniMeSettings = {};
var MiniMeStaticItems = { hair: [], bottom: [], top: [], shoes: [] };
var MiniMeLastVersion = 0;
var MiniMeLastVersionSaved = 0;
var MiniMeLastVersionSaving = 0;
var MiniMeSpeechBubbles = [];
var MiniMeWasSaveReminderBubbleShown = false;

const MINI_ME_EVENTS = {
	HIDE_PROGRESS_INDICATOR: 'miniMe:hideProgressIndicator',
	SHOW_SUCCESSFUL_SAVE_BUBBLE: 'miniMe:showSuccessfulSaveBubble',
	SAVE_REQUESTED: 'miniMe:saveRequested',
	SELECTED_ITEMS_READY: 'miniMe:selectedItemsReady',
	CHANGE_ITEM_COLOR: 'miniMe:changeItemColor'
};

const MINI_ME_CLOSET_EVENTS = {
	SELECTED_ITEM_CHANGED: 'miniMeCloset:selectedItemChanged'
};

const MINI_ME_SCALE_SETTINGS = {
	CANVAS_HEIGHT: 727, //SVG canvas height
	CURRENT_MINIME_OFFSET_Y: -69, //Current MiniMe transform offset (from copySelectedItemsToDocument)
	SAFETY_MARGIN_Y: 20,
	DEFAULT_MARGIN_Y: 5,
	SAFE_SCALE: 0.95 //Scale down slightly to ensure no cropping occurs
}

class MiniMeMain extends DOMAttached {
	constructor(el, options) {
		super(el, options);

		window.MiniMeMainInstance = this;

		this.options = options;
		this.namespace = "http://www.w3.org/2000/svg";
		this.lastSave = null;
		this.itemInstancePrefix = this.options.designedItemIdPrefix;
		this.progressIndicator = new ProgressIndicator(this.el);
		this.progressIndicator.showProgressIndicator(true, ".mia-Column", false);
		this.safeObserve(document, MINI_ME_EVENTS.HIDE_PROGRESS_INDICATOR, () => this.progressIndicator.hideProgressIndicator());
		this.safeObserve(document, MINI_ME_EVENTS.SHOW_SUCCESSFUL_SAVE_BUBBLE, () => this.showSuccessfulSaveBubble());
		this.safeObserve(document, MINI_ME_EVENTS.SAVE_REQUESTED, () => this.saveButtonClick(true));
		this.safeObserve(document, MINI_ME_EVENTS.CHANGE_ITEM_COLOR, () => this.showSaveReminderBubble());
		this.safeObserve(document, MINI_ME_CLOSET_EVENTS.SELECTED_ITEM_CHANGED, () => this.showSaveReminderBubble());

		//sounds
		this.playFeedbackSound = this.options.feedbackSoundOn;

		if (GenericSoundsInstance == null) {
			new GenericSounds(this.playFeedbackSound);
		}

		MiniMeSettings = JSON.parse(options.settings);
		this.ensureSelectedItemConfiguration();
		this.validateMiniMeSettings();
		MiniMeStaticItems.face = options.staticFace;
		MiniMeStaticItems.hair = options.staticHair;
		MiniMeStaticItems.bottom = options.staticBottom;
		MiniMeStaticItems.top = options.staticTop;
		MiniMeStaticItems.shoes = options.staticShoes;
		MiniMeSpeechBubbles = options.speechBubbles;
		this.loadItems();
	}

	ensureSelectedItemConfiguration() {
		var defaultSettings = JSON.parse(this.options.defaultSettings);
		this.ensureSelectedItemConfigurationFor('hair', defaultSettings.hair);
		this.ensureSelectedItemConfigurationFor('face', defaultSettings.face);
		this.ensureSelectedItemConfigurationFor('top', defaultSettings.top);
		this.ensureSelectedItemConfigurationFor('bottom', defaultSettings.bottom);
		this.ensureSelectedItemConfigurationFor('shoes', defaultSettings.shoes);
	}

	ensureSelectedItemConfigurationFor(itemKey, defaultSetting) {
		if (MiniMeSettings[itemKey] == undefined || MiniMeSettings[itemKey] == null) {
			MiniMeSettings[itemKey] = defaultSetting;
		}
	}

	validateMiniMeSettings() {
		this.miniMeSettingsAreValid = true;

		if (this.isSelectedCustomItemMissing(MiniMeSettings.bottom, this.options.customBottoms)) {
			MiniMeSettings.bottom = 1;
			this.miniMeSettingsAreValid = false;
		}

		if (this.isSelectedCustomItemMissing(MiniMeSettings.top, this.options.customTops)) {
			MiniMeSettings.top = 1;
			this.miniMeSettingsAreValid = false;
		}

		if (this.isSelectedCustomItemMissing(MiniMeSettings.shoes, this.options.customShoes)) {
			MiniMeSettings.shoes = 1;
			this.miniMeSettingsAreValid = false;
		}
	}

	isSelectedCustomItemMissing(setting, customItems) {
		return typeof(setting) == "string"
			&& setting.indexOf(this.itemInstancePrefix) === 0
			&& customItems.map(function(i) { return i.id; }).indexOf(setting.substring(this.itemInstancePrefix.length)) == -1;
	}

	loadItems() {
		var svgDatas = [{
			"id": this.options.blank.id,
			"relativePath": this.options.blank.relativePath
		}];

		svgDatas = svgDatas.concat(
			this.getSvgData(this.options.staticFace),
			this.getSvgData(this.options.staticHair),
			this.getSvgData(this.options.staticTop),
			this.getSvgData(this.options.staticBottom),
			this.getSvgData(this.options.staticShoes));

		axios(this.options.itemsLoadUrl, {
			method: 'post',
			headers: {
				'content-type': 'application/x-www-form-urlencoded'
			},
			data: { svgData: JSON.stringify(svgDatas) }
		}).then(this.onSuccess.bind(this));
	}

	getSvgData(staticItems) {
		return staticItems.map(function(item) {
			return {
				"id": item.id,
				"relativePath": item.relativePath
			};
		});
	}

	onSuccess(req) {
		var json = req.data;
		var node = document.createElement('div');
		node.innerHTML = json.content;
		document.body.appendChild(node);
		this.initializeSVG();
		scaleToContainerWidth();

		// Reveal editor only after first scaling to avoid showing stretched content under the loader
		if (this.editor){
			this.editor.style.visibility = 'visible';
		}

		this.progressIndicator.hideProgressIndicator();
	}

	initializeSVG() {
		this.editor = document.getElementById(this.options.miniMeEditorId);

		// Hide editor until first correct scale is applied
		if (this.editor) {
			this.editor.style.visibility = 'hidden';
		}

		this.speechBubble = new MiniMeSpeechBubble(this.editor);
		this.initializeColorSelector();
		this.initializeBackground();
		this.initializeMiniMe();
		this.initializeSpeechBubble();
	}

	// Show a warning to the user that pending changes might not be saved yet.
	// Only shown once after the first change.
	showSaveReminderBubble() {
		if (!MiniMeWasSaveReminderBubbleShown) {
			this.speechBubble.show(MiniMeSpeechBubbles["saveChanges"], 5000);
			MiniMeWasSaveReminderBubbleShown = true;
		}
	}

	saveButtonClick(sound) {
		if (sound) {
			GenericSoundsInstance.softClickSound();
		}

		var version = MiniMeLastVersion;
		if (version <= MiniMeLastVersionSaved || version <= MiniMeLastVersionSaving) {
			return;
		}
		MiniMeLastVersionSaving = version;

		if (ChangeInProgress) {
			return;
		}

		//copy to second svg
		var miniMeDocument = document.getElementById(this.options.miniMeContainerForSavingId).getSVGDocument();

		this.copyBackgroundColorToDocument(miniMeDocument);

		var miniMe = document.createElementNS(this.namespace, 'g');
		this.copySelectedItemsToDocument(miniMe);
		miniMeDocument.getElementById('layer1').appendChild(miniMe);

		//save accessory settings
		var accSettings = this.accessoryManager.saveAccessorySettings();

		// Calculate scaling to prevent cropping
		var scalingTransform = this.calculateScalingTransform(accSettings.dimensions);
		
		if (scalingTransform.scale < 1) {
			this.applyScalingToMiniMe(miniMe, scalingTransform);
		}

		var svgSaver = new SaveableSVG(miniMeDocument, this.options.savePictureUrl, this.retrySaving.bind(this));

		this.progressIndicator.showProgressIndicator(true, ".mia-Column", false);
		svgSaver.saveSVG(accSettings.parameters, accSettings.ids, version);

		miniMe.remove();

		MiniMeWasSaveReminderBubbleShown = false;
	}

	showSuccessfulSaveBubble() {
		this.speechBubble.show(MiniMeSpeechBubbles["successfulSave"], 5000);
	}

	calculateScalingTransform(dimensions) {
		
		if (!dimensions || dimensions.length === 0) {
			//No dimensions provided, returning identity transform
			return { scale: 1, offsetY: 0 };
		}

		// Calculate the maximum bounds of all accessories
		var maxTop = dimensions[0].y;
		var maxBottom = dimensions[0].y + dimensions[0].height;
		
		for (var i = 1; i < dimensions.length; i++) {
			var dimension = dimensions[i];
			
			var accessoryTop = dimension.y;
			var accessoryBottom = dimension.y + dimension.height;
			
			maxTop = Math.min(maxTop, accessoryTop);
			maxBottom = Math.max(maxBottom, accessoryBottom);
		}
		
		// Calculate the actual position in the canvas after MiniMe transform
		var actualTop = maxTop + MINI_ME_SCALE_SETTINGS.CURRENT_MINIME_OFFSET_Y;
		var actualBottom = maxBottom + MINI_ME_SCALE_SETTINGS.CURRENT_MINIME_OFFSET_Y;
		
		// Check if any part goes outside the canvas bounds
		var needsScaling = actualTop < 0 || actualBottom > MINI_ME_SCALE_SETTINGS.CANVAS_HEIGHT;
		
		if (!needsScaling) {
			//No scaling needed, all accessories fit within canvas
			return { scale: 1, offsetY: 0 };
		}
		
		// Calculate how much we need to scale to fit everything
		// We need to ensure the scaled content fits within canvas bounds
		var contentHeight = actualBottom - actualTop;
		
		// Calculate scale factors to fit within canvas
		var scaleY = MINI_ME_SCALE_SETTINGS.CANVAS_HEIGHT / contentHeight;
		
		// But we also need to account for the offset - if content goes outside bounds,
		// we need to scale down more to fit it
		var scaleForOffsetY = 1;

		if (actualTop < 0) {
			scaleForOffsetY = (MINI_ME_SCALE_SETTINGS.CANVAS_HEIGHT / (MINI_ME_SCALE_SETTINGS.CANVAS_HEIGHT - actualTop)) * MINI_ME_SCALE_SETTINGS.SAFE_SCALE;
		}
		if (actualBottom > MINI_ME_SCALE_SETTINGS.CANVAS_HEIGHT) {
			scaleForOffsetY = Math.min(scaleForOffsetY, MINI_ME_SCALE_SETTINGS.CANVAS_HEIGHT / actualBottom);
		}
		
		// Use the most restrictive scale
		var scale = Math.min(scaleY, scaleForOffsetY);
		
		// Calculate minimal offset to prevent cropping
		var offsetY = MINI_ME_SCALE_SETTINGS.DEFAULT_MARGIN_Y;
		
		// If content goes outside top edge, move it down with small safety margin
		if (actualTop * scale < 0) {
			offsetY = -actualTop * scale + MINI_ME_SCALE_SETTINGS.SAFETY_MARGIN_Y; // Add 20px safety margin
		}
		// If content goes outside bottom edge, move it up
		if (actualBottom * scale > MINI_ME_SCALE_SETTINGS.CANVAS_HEIGHT) {
			offsetY = MINI_ME_SCALE_SETTINGS.CANVAS_HEIGHT - actualBottom * scale;
		}
		
		var result = {
			scale: scale,			
			offsetY: offsetY
		};
		return result;
	}

	/**
	 * Apply scaling transform to the MiniMe group
	 */
	applyScalingToMiniMe(miniMe, transform) {
		
		// Get current transform
		var currentTransform = miniMe.getAttribute("transform") || "";
		
		// Create new transform string
		var newTransform = "translate(0," + transform.offsetY + ") scale(" + transform.scale + ")";
		
		// Combine with existing transform
		if (currentTransform) {
			newTransform = currentTransform + " " + newTransform;
		}
		
		// Apply the transform
		miniMe.setAttribute("transform", newTransform);
	}

	copyBackgroundColorToDocument(miniMeDocument) {
		miniMeDocument.getElementById("bgStop1").style.stopColor = this.editor.getElementById("bgStop1").style.stopColor;
		miniMeDocument.getElementById("bgStop2").style.stopColor = this.editor.getElementById("bgStop2").style.stopColor;
	}

	copySelectedItemsToDocument(miniMe) {
		miniMe.setAttribute("transform", "translate(127,-69)");

		miniMe.appendChild(this.cloneNodeById('accessories-post'));

		miniMe.appendChild(this.cloneNodeById('body'));
		miniMe.appendChild(this.cloneNodeById('face' + MiniMeSettings.face));

		miniMe.appendChild(this.cloneClothingNodeByKey('bottom'));
		miniMe.appendChild(this.cloneClothingNodeByKey('top'));
		miniMe.appendChild(this.cloneClothingNodeByKey('shoes'));

		miniMe.appendChild(this.cloneNodeById('hair' + MiniMeSettings.hair));

		miniMe.appendChild(this.cloneNodeById('accessories-pre'));
	}

	cloneClothingNodeByKey(key) {
		var setting = MiniMeSettings[key];
		if (typeof(setting) == "string" && setting.indexOf(this.itemInstancePrefix) === 0) {
			return document.getElementById(setting).cloneNode();
		}

		return this.cloneNodeById(key + setting);
	}

	cloneNodeById(id) {
		var groupElement = document.createElementNS(this.namespace, 'g');
		var selectedItem = document.getElementById(id);

		for (var child = selectedItem.firstElementChild; child != null; child = child.nextElementSibling) {
			if (child.tagName !== "metadata") {
				groupElement.appendChild(child.cloneNode(true));
			}
		}
		return groupElement;
	}

	retrySaving() {
		MiniMeLastVersionSaving--;
		this.saveButtonClick(false, true);
	}

	initializeBackground() {
		var svg = this.editor;
		this.bgStop1 = svg.getElementById("bgStop1");
		this.bgStop2 = svg.getElementById("bgStop2");

		var settings = MiniMeSettings;
		if (typeof(settings.background) == "undefined") {
			settings.background = {};
		}
		if (settings.background.backgroundcolor != null) {
			this.bgStop1.style.stopColor = "#" + this.decToHex(settings.background.backgroundcolor);
			this.bgStop2.style.stopColor = "#" + this.decToHex(settings.background.backgroundcolor);
		}

		this.safeObserve(svg.getElementById("background"), "mouseup", function() { this.colorBackground(); }.bind(this));
	}

	colorBackground() {
		if (ColorSelectorActiveColor != null) {

			this.bgStop1.style.stopColor = this.getActiveColor(ColorSelectorActiveColor);
			this.bgStop2.style.stopColor = this.getActiveColor(ColorSelectorActiveColor);
			GenericSoundsInstance.softClickSound();
			MiniMeSettings.background.backgroundcolor = this.hexToDec(this.getActiveColor(ColorSelectorActiveColor).substring(1));
			MiniMeLastVersion++;
			ColorSelectorActiveColor = null;
			this.colorSelector.resetColors();
		}
	}

	initializeColorSelector() {
		this.colorSelector = new ColorSelector(this.editor, this.options.colorSelectorColors, 450, 798, true, this.playFeedbackSound, this.speechBubble);
	}

	initializeMiniMe() {
		//insert everything inside a document fragment to do only one page reflow
		var fragment = document.createDocumentFragment();

		var options = this.options;
		var colorSelector = this.colorSelector;

		var blank = new ColorableSvgItem(colorSelector, this.createBlankSvg(), options.blank.objectChains[0][0], options.blank.objectChains[0][options.blank.objectChains[0].length - 1]);
		fragment.appendChild(blank.item);

		this.MiniMeSections = [
			new MiniMeFaces(fragment, colorSelector, options.facesCategoryName, options.designedItemIdPrefix),
			new MiniMeBottom(fragment, colorSelector, options.customBottoms, options.bottomsCategoryName, options.designedItemIdPrefix),
			new MiniMeTop(fragment, colorSelector, options.customTops, options.topsCategoryName, options.designedItemIdPrefix),
			new MiniMeHair(fragment, colorSelector, options.hairCategoryName, options.designedItemIdPrefix),
			new MiniMeShoes(fragment, colorSelector, options.customShoes, options.shoesCategoryName, options.designedItemIdPrefix)
		]

		this.editor.getElementById("character").appendChild(fragment);

		this.selectedItemsByCategory = this.MiniMeSections.reduce(
			(object, miniMeSection) => {
				object[miniMeSection.groupIdentifier] = miniMeSection.getSelectedItemId();
				return object;
			},
		{});

		queueMicrotask(() => {
			document.dispatchEvent(new CustomEvent('miniMe:selectedItemsReady'));
		});

		this.accessoryManager = new MiniMeAccessoryManager(this.editor, this.options.accessories, this.playFeedbackSound, this.speechBubble);
	}

	createBlankSvg() {
		var useSvg = document.createElementNS(this.namespace, 'use');
		useSvg.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#bodycolor');
		return useSvg;
	}

	initializeSpeechBubble() {
		if (this.options.firstMiniMe) {
			this.speechBubble.show(MiniMeSpeechBubbles["firstMiniMe"]);
		} else if (!this.miniMeSettingsAreValid) {
			this.speechBubble.show(MiniMeSpeechBubbles["changeAvatar"]);
		} else {
			this.speechBubble.show(MiniMeSpeechBubbles["initial"]);
		}
	}

	hexToDec(hex) {
		return parseInt("FF" + hex, 16);
	}

	decToHex(dec) {
		return dec.toString(16).toUpperCase().substring(2);
	}

	colorToHex(color) {
		if (color.substr(0, 1) === '#') {
			return color;
		}
		var digits = /(.*?)rgb\((\d+), (\d+), (\d+)\)/.exec(color);

		var red = parseInt(digits[2]);
		var green = parseInt(digits[3]);
		var blue = parseInt(digits[4]);

		var rgb = blue | (green << 8) | (red << 16);
		var rgb16 = rgb.toString(16);
		while (rgb16.length < 6) {
			rgb16 = "0" + rgb16;
		}
		return digits[1] + '#' + rgb16;
	}

	getActiveColor() {
		return this.colorToHex(ColorSelectorActiveColor);
	}

	onUnload(ev) {
		super.onUnload(ev);

		// Clear global references when instance is destroyed
		if (window.MiniMeMainInstance === this) {
			window.MiniMeMainInstance = null;
		}
	}
}
